import React from 'react';
import { Link } from "react-scroll";
import { FiArrowRight, FiMail, FiHeadphones, FiMapPin, FiCheck } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderTwo from '../common/coheader/HeaderTwo';
import HeaderTopBar from '../common/coheader/HeaderTopBar';
import CoTabThree from '../elements/tab/CoTabThree';
import Slider from "react-slick";
import { BannerActivation } from "../utils/script";
import BenefitSection from "../elements/benefit/BenefitSection";
import BenefitSection2 from "../elements/benefit/BenefitSection2";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import CalltoActionFive from "../elements/calltoaction/CalltoActionFive";
import CoServiceOne from "../elements/service/CoServiceOne";
import FooterTwo from '../common/cofooter/FooterTwo';
import Copyright from '../common/cofooter/Copyright';
import Separator from "../elements/separator/Separator";
import ContactForm from "../elements/contact/ContactForm";
import { useTranslation } from "react-i18next";
import TypewriterComponent from 'typewriter-effect';

const Community = () => {
    const { t } = useTranslation('community');
    const BannerData = [
        {
            image: t('home.img1'),
            title: t('home.title'),
            description: t('home.subtitle'),
        },
        {
            image: t('home.img2'),
            title: t('home.title2'),
            description: t('home.subtitle2'),
        },
        {
            image: t('home.img3'),
            title: t('home.title3'),
            description: t('home.subtitle3'),
        },
        {
            image: t('home.img4'),
            title: t('home.title4'),
        },
    ]
    const EmpData = [
        {
            title: t('avantages.creerDuLien.title'),
            description: t('avantages.creerDuLien.content'),
        },
    ]
    const CommitmentData = [
        {
            title: t('entrepriseMission.rse.engagementTitle1'),
            description: t('entrepriseMission.rse.engagementSubtitle1'),
            p1: t('entrepriseMission.rse.engagementList1Point1'),
            p2: t('entrepriseMission.rse.engagementList1Point2'),
            p3: t('entrepriseMission.rse.engagementList1Point3'),
        }
    ]
    const ManagementData = [
        {
            title: t('entrepriseMission.rse.engagementTitle2'),
            description: t('entrepriseMission.rse.engagementSubtitle2'),
            p1: t('entrepriseMission.rse.engagementList2Point1'),
            p2: t('entrepriseMission.rse.engagementList2Point2'),
            p3: t('entrepriseMission.rse.engagementList2Point3'),
        }
    ]


    return (
        <>
            <SEO title="N01ZET Community - Recognition and Rewards Saas Platform for Members from Associations and fundations" />
            <main className="page-wrapper main-mobile-responsive" id='home'>
                <HeaderTopBar />
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />
                {/* Start Slider Area  */}
                <Slider className="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow" {...BannerActivation}>
                    {BannerData.map((data, index) => (
                        <div key={index} className="single-slide">
                            <div className="height-950 bg-overlay bg_image" >
                                <div className="container">
                                    <div className="row row--30 align-items-center">
                                        <div className="order-2 order-lg-1 col-lg-6">
                                            <div className="inner text-left">
                                                <h1 className="title cust-title"><TypewriterComponent
                                                    options={{
                                                        strings: (data.title),
                                                        autoStart: true,
                                                        loop: true,
                                                    }}
                                                    onInit={(slidertype) => {
                                                        slidertype
                                                            .pauseFor(1000)
                                                            .start();
                                                    }}
                                                /></h1>
                                                <p className="description" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                                                <div className="button-group">
                                                    <Link className="btn-default btn-medium btn-icon co-btn" to="offers" smooth={true} offset={-70} duration={500}>{t('footer.offres')}<i className="icon"><FiArrowRight /></i></Link>
                                                    <Link className="btn-default btn-medium btn-border btn-icon cust-color" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.beContacted')}<i className="icon"><FiArrowRight /></i></Link>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="order-2 order-lg-1 col-lg-6">
                                            <img style={{ marginLeft: '80px', marginTop: '80px' }} className="bannerimg" alt="slides" src={`${process.env.PUBLIC_URL}${data.image}`} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                {/* End Slider Area  */}

                {/* Start Principle Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('home.principe')}
                                    description={t('home.principeSubtitle')}
                                />
                            </div>
                        </div>
                        <CoServiceOne
                            serviceStyle="service__style--1 bg-color-blackest radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Principle Area  */}

                {/* Start Mission Based Area  */}
                <div className='about-area about-style-4' id='mission'>
                <div className="rn-service-area" id='mission'>
                    <div className="container">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('header.entrepriseMission')}
                                />
                        <div className="row">
                            <div className="col-lg-6 service__style--1 bg-color-blackest radius mt--20 rbt-border p-5">
                                {CommitmentData.map((data) => (
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title" dangerouslySetInnerHTML={{ __html: data.title }}></h3>
                                        <ul className="feature-list">
                                            <li>
                                            <p style={{margin:"0px"}} dangerouslySetInnerHTML={{ __html: data.description }}></p>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text" style={{marginTop:"0px",marginBottom:"0px"}} dangerouslySetInnerHTML={{ __html: data.p1 }}></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text"  style={{marginTop:"0px",marginBottom:"0px"}} dangerouslySetInnerHTML={{ __html: data.p2 }}></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text"  style={{marginTop:"0px",marginBottom:"0px"}} dangerouslySetInnerHTML={{ __html: data.p3 }}></p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                ))}
                            </div>
                            
                            <div className="col-lg-6 service__style--1 bg-color-blackest radius mt--20 rbt-border p-5">
                                {ManagementData.map((data) => (
                                <div className="content">
                                    <div className="inner">
                                        <h3 className="title" dangerouslySetInnerHTML={{ __html: data.title }}></h3>
                                        <ul className="feature-list">
                                            <li>
                                                <p style={{margin:"0px"}} dangerouslySetInnerHTML={{ __html: data.description }}></p>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text" style={{ marginTop: "0px", marginBottom: "0px" }} dangerouslySetInnerHTML={{ __html: data.p1 }}></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text" style={{ marginTop: "0px", marginBottom: "0px" }} dangerouslySetInnerHTML={{ __html: data.p2 }}></p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <FiCheck />
                                                </div>
                                                <div className="title-wrapper">
                                                    <p className="text" style={{ marginTop: "0px", marginBottom: "0px" }} dangerouslySetInnerHTML={{ __html: data.p3 }}></p>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="about-btn mt--30">
                                            <Link className="btn-default btn-medium btn-icon co-btn" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.beContacted')}<i className="icon"><FiArrowRight /></i></Link>
                                        </div>
                                    </div>
                                </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                {/* End Mission Based Area  */}


                {/* Start Benefit Area  */}
                <div className="rn-service-area rn-section-gap " id='benefits'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('avantages.raisons.title')}
                                    description={t('avantages.raisons.subtitle')}
                                />
                            </div>
                        </div>
                        <BenefitSection
                            number="01."
                            title={t('avantages.raisons.un.title')}
                            description={t('avantages.raisons.un.content')}
                            image="/coimages/split/edu-1.png"
                            btnClass='theme-cogradient'
                        />
                        <BenefitSection2
                            number="02."
                            title={t('avantages.raisons.deux.title')}
                            description={t('avantages.raisons.deux.content')}
                            image="/coimages/split/benefits-2.png"
                            btnClass='theme-cogradient'
                        />
                        <BenefitSection
                            number="03."
                            title={t('avantages.raisons.trois.title')}
                            description={t('avantages.raisons.trois.content')}
                            image="/coimages/split/benefits-3.png"
                            btnClass='theme-cogradient'
                        />
                        <BenefitSection2
                            number="04."
                            title={t('avantages.raisons.quatre.title')}
                            description={t('avantages.raisons.quatre.content')}
                            image="/coimages/split/benefits-4.png"
                            btnClass='theme-cogradient'
                        />
                        <BenefitSection
                            number="05."
                            title={t('avantages.raisons.cinq.title')}
                            description={t('avantages.raisons.cinq.content')}
                            image="/coimages/split/benefits-5.png"
                            btnClass='theme-cogradient'
                        />
                        <div className='text-center pt-5 mt-5'>
                            <Link className="btn-default btn-medium btn-icon co-btn" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.demo')}<i className="icon"><FiArrowRight /></i></Link>
                        </div>
                    </div>
                </div>
                {/* End Benefit Area  */}

                <Separator />

                {/* Start Members  */}
                <div className="about-area about-style-4 rn-section-gap">
                    {EmpData.map((data) => (
                        <div className="container">
                            <div className="row row--40 align-items-center pt-5 pb-5 lt-display">
                                <div className="col-lg-6 mt_md--40 mt_sm--40">
                                    <div className="content">
                                        <div className="inner">
                                            <h3 className="title" dangerouslySetInnerHTML={{ __html: data.title }}></h3>
                                            <ul className="feature-list">
                                                <li dangerouslySetInnerHTML={{ __html: data.description }}></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="video-btn">
                                        <img src={`${process.env.PUBLIC_URL + t('avantages.creerDuLien.imgSrc')}`} alt="process" width={"500px"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* End Members  */}

                <Separator />

                {/* Start How It Works Area  */}
                <div className="rn-service-area rn-section-gap" id='functioning'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('fonctionnement.simplicité.title')}
                                    description={t('fonctionnement.simplicité.subtitle')}
                                />
                            </div>
                        </div>
                        <BenefitSection2
                            number=""
                            title={t('fonctionnement.simplicité.un.title')}
                            description={t('fonctionnement.simplicité.un.content')}
                            image="/coimages/split/works-1.png"
                            btnClass='theme-cogradient'
                        />
                        <BenefitSection
                            number=""
                            title={t('fonctionnement.simplicité.deux.title')}
                            description={t('fonctionnement.simplicité.deux.content')}
                            image="/coimages/split/works-2.png"
                            btnClass='theme-cogradient'
                        />
                        <BenefitSection2
                            number=""
                            title={t('fonctionnement.simplicité.trois.title')}
                            description={t('fonctionnement.simplicité.trois.content')}
                            image="/coimages/split/works-3.png"
                            btnClass='theme-cogradient'
                        />
                        <div className='text-center pt-5 mt-5'>
                            <Link className="btn-default btn-medium btn-icon co-btn" to="contactform" smooth={true} offset={-70} duration={500}>{t('buttons.demo')}<i className="icon"><FiArrowRight /></i></Link>
                        </div>
                    </div>
                </div>
                {/* End How It Works Area  */}

                <Separator />

                {/* Start One-stop shop Area  */}
                <div className="rwt-tab-area rn-section-gap" id='offers'>
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('home.offresTitle')}
                                    description={t('home.offresSubtitle')}
                                />
                            </div>
                        </div>
                        <CoTabThree />
                    </div>
                </div>
                {/* End One-stop shop Area  */}

                {/* Start Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                                <CalltoActionFive
                                    title={t('footer.readytotake')}
                                    subtitle={t('footer.finest')}
                                    btnText={t('buttons.demo')}
                                    btnClass='co-btn'
                                />
                    </div>
                </div>
                {/* End Call To Action Area  */}
                <Separator />

                {/* Start Contact Form Area  */}
                <div className="rwt-tab-area rn-section-gap" id='contactform'>
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('contactPage.subtitle')}
                                    description=''
                                />
                            </div>
                        </div>
                        <div className="row mt--40 row--15">
                            <div className="col-lg-7">
                                <ContactForm  btnClass="co-btn" formStyle="contact-form-1" />
                            </div>
                            <div className="col-lg-5 mt_md--30 mt_sm--30">
                                <div className="row">
                                    <div className="col-lg-12 col-md-6 col-12">
                                        <div className="rn-contact-box">
                                            <div className="icon">
                                                <FiMail />
                                            </div>
                                            <div className="inner">
                                                <h4 className="title rn-title-font">{t('contactPage.email')}</h4>
                                                <p><a href="mailto:support@n01zet.com">support@n01zet.com</a></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-6 col-12">
                                        <div className="rn-contact-box">
                                            <div className="icon">
                                                <FiMapPin />
                                            </div>
                                            <div className="inner">
                                                <h4 className="title rn-title-font">{t('contactPage.location')}</h4>
                                                <p>33 rue La Fayette 75009 Paris FRANCE</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Contact Form Area  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default Community
